function InvoicePatterns() {
    return (
        <div className="row">
            <div className="col-xl-12">
                <div className="card stretch stretch-full">
                    <div className="card-header">
                        <h5 className="card-title">الگو های صورتحساب</h5>
                    </div>
                    <div className="card-body custom-card-action p-0">
                        <div className="table-responsive">
                            <table className="table table-hover mb-0">
                                <thead>
                                    <tr className="border-b">
                                        <th scope="row">کد</th>
                                        <th>عنوان الگو صورتحساب</th>
                                        <th className="text-center">نوع اول</th>
                                        <th className="text-center">نوع دوم</th>
                                        <th className="text-center">نوع سوم</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td>الگو اول ( فروش )</td>
                                        <td className="text-center">
                                            <i className="feather-check text-success fs-3"></i>
                                        </td>
                                        <td className="text-center">
                                            <i className="feather-check text-success fs-3"></i>
                                        </td>
                                        <td className="text-center">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <td>الگو دوم ( فروش ارز )</td>
                                        <td className="text-center">
                                            <i className="feather-check text-success fs-3"></i>
                                        </td>
                                        <td className="text-center">
                                        </td>
                                        <td className="text-center">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>3</td>
                                        <td>الگو سوم ( طلا، جواهر و پلاتین )</td>
                                        <td className="text-center">
                                            <i className="feather-check text-success fs-3"></i>
                                        </td>
                                        <td className="text-center">
                                            <i className="feather-check text-success fs-3"></i>
                                        </td>
                                        <td className="text-center">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>4</td>
                                        <td>الگو چهارم ( قرارداد پیمانکاری )</td>
                                        <td className="text-center">
                                            <i className="feather-check text-success fs-3"></i>
                                        </td>
                                        <td className="text-center">
                                        </td>
                                        <td className="text-center">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>5</td>
                                        <td>الگو پنجم ( قبوض خدماتی )</td>
                                        <td className="text-center">
                                            <i className="feather-check text-success fs-3"></i>
                                        </td>
                                        <td className="text-center">
                                        </td>
                                        <td className="text-center">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>6</td>
                                        <td>الگو ششم ( بلیط هواپیما )</td>
                                        <td className="text-center">
                                            <i className="feather-check text-success fs-3"></i>
                                        </td>
                                        <td className="text-center">
                                        </td>
                                        <td className="text-center">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>7</td>
                                        <td>الگو هفتم ( صادرات )</td>
                                        <td className="text-center">
                                            <i className="feather-check text-success fs-3"></i>
                                        </td>
                                        <td className="text-center">
                                        </td>
                                        <td className="text-center">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>8</td>
                                        <td>الگو هشتم ( بارنامه )</td>
                                        <td className="text-center">
                                            <i className="feather-check text-success fs-3"></i>
                                        </td>
                                        <td className="text-center">
                                        </td>
                                        <td className="text-center">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>9</td>
                                        <td>الگو یازدهم ( بورس اوراق بهادار مبتنی بر کالا )</td>
                                        <td className="text-center">
                                            <i className="feather-check text-success fs-3"></i>
                                        </td>
                                        <td className="text-center">
                                        </td>
                                        <td className="text-center">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default InvoicePatterns;